import { render } from "./flashcards-index.vue?vue&type=template&id=6875aa7c"
import script from "./flashcards-index.vue?vue&type=script&lang=js"
export * from "./flashcards-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__